module.exports = __webpack_public_path__ + "media/applicants/icon-store-3665be09.png";